import GModal from "components/ui/modal/Modal";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Box, Flex, Stack, useToast } from "@chakra-ui/react";
import { useForm } from "react-hook-form";
import GButton from "components/ui/button/Button";
import MultiSelect from "components/ui/multiSelect/MultiSelect";
import { useDispatch, useSelector } from "react-redux";
import Input from "components/form/Input";
import {
  getCallcenter,
  editInventoryCount,
  getInventoryCountDetails,
} from "../../services/inventoryCountService";

const EditInventoryCountModal = ({ onClose, id }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const toast = useToast({
    position: "top",
    duration: 3000,
    status: "success",
  });
  const toast2 = useToast({ position: "top", duration: 3000, status: "error" });
  const { handleSubmit, control, setValue } = useForm();

  const productionsData = useSelector((state) => state.inventoryCount);

  useEffect(() => {
    dispatch(getCallcenter());
  }, [dispatch]);

  return (
    <GModal
      onClose={onClose}
      modalHeader={t("pages.inventory_count.edit_inventory_count")}
      modalContent={
        <Box p={4}>
          <form
            onSubmit={handleSubmit((values) => {
              values.UserId = localStorage.getItem("userId");
              if (values.BranchId === undefined) {
                toast2({ description: t("validation.choose_first") });
              } else {
                values.BranchId = values.BranchId.BranchId;
                values.InventoryCountId = id.InventoryCountId;
                dispatch(editInventoryCount(values))
                  .unwrap()
                  .then((_) => {
                    toast({
                      description: t(
                        "pages.inventory_count.inventory_count_updated"
                      ),
                    });
                    dispatch(getInventoryCountDetails(id));
                    onClose();
                  });
              }
            })}
          >
            <Stack spacing={6}>
              <MultiSelect
                title={t("pages.inventory.branch")}
                data={productionsData.DropData.map((el) => ({
                  ...el,
                  label: el.BranchName,
                  value: el.BranchId,
                }))}
                isMulti={false}
                isRequired={true}
                onChange={(e) => setValue("BranchId", e)}
              />

              <Input
                label={t("pages.inventory_count.notes")}
                labelStyle={{ textTransform: "capitalize" }}
                placeholder={t("pages.inventory_count.notes")}
                name="Notes"
                isFormController
                control={control}
              />

              <Flex gap={4}>
                <GButton
                  type="submit"
                  title={t("general.save")}
                  bg="primary"
                  color="light"
                  border="1px solid transparent"
                  hover={{
                    color: "primary",
                    borderColor: "primary",
                    bg: "none",
                  }}
                />
                <GButton
                  title={t("general.close")}
                  onClick={onClose}
                  bg="red.600"
                  border="1px solid transparent"
                  color="light"
                  hover={{
                    color: "red.600",
                    borderColor: "red.600",
                    bg: "none",
                  }}
                />
              </Flex>
            </Stack>
          </form>
        </Box>
      }
    />
  );
};

export default EditInventoryCountModal;
